// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ChatBubbleBottomCenterTextIcon, ExclamationTriangleIcon, ArrowPathIcon, TagIcon, BuildingStorefrontIcon, ArchiveBoxIcon, ClipboardDocumentListIcon, TruckIcon as HeroTruckIcon, ShoppingBagIcon, ClockIcon, StarIcon } from '@heroicons/react/24/outline'

// Thông tin nhân viên mặc định
export const staffInfo = {
  id: '1',
  fullName: 'Ngọc Lan',
  nickname: 'Lan',
  role: 'Nhân viên bán hàng',
  phone: '0909090909',
  email: 'ngoclan@gmail.com',
  department: 'Sales',
  store: 'CH Quận 3',
  joinDate: '2024-01-01'
}

export interface QuickSuggestion {
  id: string
  title: string
  icon: React.ComponentType<any>
  meaning: string
}

export const quickSuggestions: QuickSuggestion[] = [
  {
    id: 'tu_van_san_pham',
    title: 'Tư vấn sản phẩm',
    icon: ShoppingBagIcon,
    meaning: 'Làm sao để ' + staffInfo.nickname + ' tư vấn sản phẩm phù hợp cho khách hàng?'
  },
  {
    id: 'khieu_nai',
    title: 'Xử lý khiếu nại',
    icon: ExclamationTriangleIcon,
    meaning: 'Hướng dẫn ' + staffInfo.nickname + ' cách xử lý khi khách hàng khiếu nại!'
  },
  {
    id: 'doi_tra',
    title: 'Đổi – Trả hàng',
    icon: ArrowPathIcon,
    meaning: 'Cho ' + staffInfo.nickname + ' xem chính sách và điều kiện đổi trả của công ty?'
  },
  {
    id: 'khuyen_mai',
    title: 'Khuyến mãi hôm nay',
    icon: TagIcon,
    meaning: 'Cho ' + staffInfo.nickname + ' xem các ưu đãi khuyến mãi của công ty hôm nay.'
  },
  {
    id: 'thoi_gian_giao_hang',
    title: 'Thời gian giao hàng',
    icon: ClockIcon,
    meaning: 'Cho ' + staffInfo.nickname + ' xem thời gian giao hàng theo khu vực, khoảng thời gian như thế nào?'
  },
  {
    id: 'kpi',
    title: 'KPI & Thưởng',
    icon: StarIcon,
    meaning: 'Cho ' + staffInfo.nickname + ' xem mục tiêu cá nhân, thưởng nóng, đánh giá sao?'
  }
]